module.exports = __webpack_public_path__ + "img/s3-img6.0bbbc6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s3-img6.png
// module id = 417
// module chunks = 0